import { Controller } from '@hotwired/stimulus';

// The error is a server-side verdict on the value the page loaded with. Once
// the user toggles the checkbox that verdict is stale, so the invalid state is
// dropped instead of lingering on a value the server never saw.
export default class extends Controller {
  static targets = ['input', 'box', 'hint'];

  static classes = ['invalid'];

  clearError() {
    this.inputTarget.removeAttribute('aria-invalid');
    this.inputTarget.removeAttribute('aria-describedby');
    this.boxTarget.classList.remove(this.invalidClass);
    if (this.hasHintTarget) this.hintTarget.remove();
  }
}
